export const findDisplayedColumn = (api, field) => {
  if (!field) return null;
  const target = field.toLowerCase();
  const displayedColumns = api?.getAllDisplayedColumns() ?? [];
  return (
    displayedColumns.find(
      (column) => column.getColDef().field?.toLowerCase() === target
    ) ?? null
  );
};

const MAX_EDIT_ATTEMPTS = 5;

const isEditingCell = (api, rowNode, column) =>
  api
    .getEditingCells()
    .some(
      (cell) => cell.rowIndex === rowNode.rowIndex && cell.column === column
    );

// A cell scrolled into view is only rendered on the next animation frame,
// and startEditingCell silently does nothing until it exists.
const startEditingWhenRendered = (api, rowNode, column, attemptsLeft) => {
  api.startEditingCell({ rowIndex: rowNode.rowIndex, colKey: column });
  if (isEditingCell(api, rowNode, column) || attemptsLeft <= 1) return;

  requestAnimationFrame(() =>
    startEditingWhenRendered(api, rowNode, column, attemptsLeft - 1)
  );
};

export const focusGridCell = (api, uniqueId, column) => {
  const rowNode = api?.getRowNode(uniqueId);
  if (!rowNode || !column) return;

  api.ensureNodeVisible(rowNode);
  api.ensureColumnVisible(column);
  api.setFocusedCell(rowNode.rowIndex, column);
  api.flashCells({ rowNodes: [rowNode], columns: [column] });

  if (column.isCellEditable(rowNode)) {
    startEditingWhenRendered(api, rowNode, column, MAX_EDIT_ATTEMPTS);
  }
};
